import React from 'react';
import { graphql, compose } from 'react-apollo';
import { getPointsEarnedStatistics } from './queries/queries';
import PointsEarnedWidget from '../../common/widgets/pointsEarned';
import DataProcessor from '../../common/dataProcessors/pointsEarnedDataProcessor';
import BaseWidget from '../../../../widgets/baseWidget';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class PointsEarned extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.group.daily.totalPointsEarned;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'day');
  }

  render() {
    return(
      <PointsEarnedWidget data={this.dataProcessor.data} loading={this.props.data.loading} title="Daily Seeds"
                          comment={this.comment}/>
    );
  }
}

export default compose(
  graphql(getPointsEarnedStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(PointsEarned);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/daily/pointsEarned.js